<virtual-scroller
  #wizScroller
  collectionContainer
  #wizNavList="wizCollContainer"
  #wizCdkTileList
  wizDragDrop
  [wizDragEnabled]="dragEnabled"
  [wizDropEnabled]="dropEnabled"
  [wizDragMove]="dragMove"
  [wizEnableSelfReorder]="enableSelfReorder"
  [wizDropControlFunction]="dropControlFunction"
  [wizShowDropIndicator]="shopDropIndicator"
  [items]="itemsForDisplay"   
  bufferAmount="20"
  [style.height]="'100%'"
  style="width: 100%; display: block;"
>
  <!-- [childWidth]="itemWidth"            
  [childHeight]="itemHeight"      -->
  

  <div
    *ngFor="let item of wizScroller.viewPortItems; let idx = index; trackBy: trackByItem"
    collectionItem
    [container]="wizNavList"
    class="tile-item"
    [style.height]="itemHeightStr"
    [style.width]="itemWidthStr"
    style="box-sizing: border-box; padding: 4px; display: inline-block;"
    [class.is-selected]="isSelected(item)"
    (click)="onItemSelect(item)"
    (mousedown)="onInitTileDrag($event, item)"
   > 
   <!--(mousedown)="onInitTileDrag($event, item)" -->
    <ng-container
      *ngTemplateOutlet="getTemplate(); context: { $implicit: item, index: idx, itemRenderer: wizItemRenderer, provider: wizDataProvider }"
    ></ng-container>
  </div>
</virtual-scroller>

<!-- Template affichage du labelField basique-->
<ng-template #defaultRenderer let-item let-index="index">
  <span style="padding-left: 5px">{{ getItemLabel(item) }}</span>
</ng-template>

<!-- Template custom renderer -->
<ng-template
  #dynamicRenderer
  let-item
  let-index="index"
  let-itemrndr="itemRenderer"
  let-provider="provider"
>
  <div
    [wizTemplateItemRenderer]="itemrndr"
    [context]="{index: index}"
    [data]="item"
    [owner]="this"
    [provider]="provider"
  ></div>
</ng-template>